<ng-container *transloco="let t; read: 'profile-list-issuer-filter'">
  <!--  Hide the issuer filter component if issuers count is less that one-->
  <div *ngIf="(issuers$ | async)?.length > 1"
    class="filter-section">
    <accredible-themeable-multiple-search-input [label]="t('credential_issuer')"
      [ariaLabel]="t('aria_credential_issuer')"
      [placeholder]="t('search_issuers')"
      [options]="issuers$ | async"
      [optionsLabelKey]="'name'"
      [selectedOptions]="selectedIssuers()"
      [usingStaticOptions]="true"
      (optionsChanged)="onSelectedIssuersChange($event)">
    </accredible-themeable-multiple-search-input>
  </div>
</ng-container>
